import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useSelector, useDispatch } from "types/store";
import styles from "./style.module.css";
import { Button } from "aible";
import { Creatable } from "react-select";
import { LineInput } from "components/Inputs/LineInput";
import { isEnabled } from "utils/featureFlags";
import AccountSelector from "containers/Accounts/AccountSelector";
import { getDefaultEmbeddingsModel, getDefaultEmbeddingsModelOptions } from "containers/ChatGPT/reducer";
import { checkAllowCorpusModelSelect, createCorpus } from "containers/LanguageModelArtifact/reducer";
import { getSelectedAccountId, getActiveAccounts } from "containers/Accounts/reducer";
import { getSelectedFolder } from "containers/Folders/reducer";
import pdfIcon from "images/file-pdf-light 1.svg";
import pdfIconPurple from "images/file-pdf-purple.svg";
import { selectOnChangeWrapper } from "utils/select";
import { CorpusProcessorType } from "components/Tiles/Sense/CorpusTile";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";
import UploadDocumentInputOnly from "@/components/LanguageModelArtifact/UploadDocumentInputOnly";
import { updateGlobalState } from "@/containers/Sense/reducer";
import { getDatasetViewMode } from "@/containers/View/reducer";
const CorpusCreate = ({ showModal, className, onClick, buttonText, rightButton, purpleIcon, style }) => {
    const dispatch = useDispatch();
    const [createShowModal, updateCreateShowModal] = useState(showModal);
    const [createdArtifactId, setCreatedArtifactId] = useState(undefined);
    const inputElement = useRef(null);
    const updateDatasetViewType = (datasetViewType) => {
        dispatch(updateGlobalState({ datasetViewType }));
    };
    const handleChangeArtifactId = (artifactId) => {
        updateDatasetViewType("UNSTRUCTURED");
        setCreatedArtifactId(artifactId);
        setTimeout(() => {
            inputElement.current?.click();
        }, 1000);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { onClick: () => {
                updateCreateShowModal(true);
                onClick && onClick();
            }, className: styles.createButton + (className ? " " + className : ""), style: style }, rightButton ? (React.createElement(React.Fragment, null,
            buttonText ? buttonText : "Create Document Set",
            React.createElement("div", { className: styles.buttonIcon, style: {
                    marginLeft: "12px"
                } },
                React.createElement("img", { src: purpleIcon ? pdfIconPurple : pdfIcon })))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.buttonIcon },
                React.createElement("img", { src: purpleIcon ? pdfIconPurple : pdfIcon })),
            buttonText ? buttonText : "Create Document Set"))),
        React.createElement(CreateCorpusModal, { showModal: createShowModal, updateShowModal: updateCreateShowModal, buttonText: buttonText, handleChangeArtifactId: handleChangeArtifactId }),
        createdArtifactId && React.createElement(UploadDocumentInputOnly, { inputElement: inputElement, artifactId: createdArtifactId })));
};
const CreateCorpusModal = ({ updateShowModal, showModal, buttonText, handleChangeArtifactId }) => {
    const dispatch = useDispatch();
    const accountId = useSelector((state) => getSelectedAccountId(state));
    const defaultModel = useSelector((state) => getDefaultEmbeddingsModel(state, accountId));
    const [name, updateName] = useState();
    const [modelId, updateModelId] = useState(defaultModel);
    const [isCreating, updateIsCreating] = useState(false);
    const [processorType, updateProcessorType] = useState(isEnabled("nv-ingest-document-processor-type") ? "nvingest" : "default");
    useEffect(() => {
        updateModelId(defaultModel);
    }, [accountId]);
    const disableSave = !(name && name?.length > 0 && modelId);
    const folderId = useSelector((state) => getSelectedFolder(state));
    const accounts = useSelector((state) => getActiveAccounts(state));
    const defaultEmbeddingsOptions = useSelector((state) => getDefaultEmbeddingsModelOptions(state));
    const allowCorpusModelSelect = checkAllowCorpusModelSelect(processorType);
    const datasetViewMode = useSelector((state) => getDatasetViewMode(state));
    const handleCreate = () => {
        if (name === undefined || modelId === undefined) {
            return;
        }
        updateIsCreating(true);
        return dispatch(createCorpus(accountId, folderId, name, modelId, processorType))
            .then((corpus) => {
            updateIsCreating(false);
            updateName(undefined);
            updateProcessorType("default");
            updateShowModal(false);
            if (datasetViewMode === "LIST") {
                handleChangeArtifactId(corpus.id);
            }
        })
            .catch((e) => {
            console.log(e);
            updateIsCreating(false);
            updateShowModal(false);
        });
    };
    return (React.createElement(Dialog, { open: showModal, onOpenChange: () => updateShowModal(false) },
        React.createElement(DialogContent, null,
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Create Document Set")),
            React.createElement("div", null,
                accounts?.length > 1 && (React.createElement("div", { className: styles.setting },
                    React.createElement("div", { className: styles.settingLabel }, "Cloud Account"),
                    React.createElement(AccountSelector, null))),
                React.createElement("div", { className: styles.setting },
                    React.createElement("div", { className: styles.settingLabel }, "Name"),
                    React.createElement(LineInput, { value: name, placeholder: "New Document Set", onChange: (val) => updateName(val), updateInstant: true })),
                isEnabled("document-set-processor-type") && (React.createElement(CorpusProcessorType, { isLoading: isCreating, processorType: processorType, updateProcessorType: updateProcessorType, corpusId: 0 })),
                allowCorpusModelSelect && (React.createElement("div", { className: styles.setting },
                    React.createElement("div", { className: styles.settingLabel }, "Embedding Model"),
                    React.createElement(Creatable, { options: defaultEmbeddingsOptions, value: defaultEmbeddingsOptions.find((o) => o.value === modelId), onChange: selectOnChangeWrapper(updateModelId), placeholder: "Select a Model", menuPlacement: "bottom", isClearable: modelId !== undefined })))),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { type: "secondary", onClick: () => updateShowModal(false) }, "Close"),
                React.createElement(Button, { type: "primary", onClick: handleCreate, style: { marginLeft: "auto" }, disabled: disableSave, isLoading: isCreating }, buttonText ? buttonText : "Create Document Set")))));
};
export default CorpusCreate;
